import React from 'react';
import ReactDOM from 'react-dom/client';

import EventSearch from './EventSearch';

const root = ReactDOM.createRoot(document.getElementById('event_search'));

root.render(
  <React.StrictMode>
    <EventSearch />
  </React.StrictMode>
);
